import * as React from 'react'
import { IconSVGType } from '../../../types/icons'

export const UnionPayCardIcon = (props: IconSVGType) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox={props.viewBox || '0 0 24 24'}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id='union-pay-card-icon'>Union Pay Card</title>
    <g clipPath='url(#clip0_3_7834)'>
      <mask
        id='mask0_3_7834'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='11'
        y='5'
        width='12'
        height='14'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.9243 5.25266H22.2616V18.513H11.9243V5.25266Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_3_7834)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.2374 5.25359L16.1249 5.25266H16.1235C16.1193 5.25266 16.1156 5.25312 16.1119 5.25312C15.4092 5.27458 14.5344 5.83771 14.3753 6.53241L11.9572 17.2309C11.7981 17.9322 12.2315 18.5028 12.9286 18.513H18.3C18.9868 18.4794 19.6539 17.9224 19.8102 17.2356L22.2284 6.53707C22.3903 5.82885 21.9466 5.25359 21.2374 5.25359Z'
          fill='#01798A'
        />
      </g>
      <mask
        id='mask1_3_7834'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='6'
        y='5'
        width='11'
        height='14'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.21497 5.25098H16.1115V18.5132H6.21497V5.25098Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1_3_7834)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.9573 17.2311L14.3755 6.5326C14.5346 5.8379 15.4094 5.27477 16.1115 5.25331L14.0788 5.25191L10.4163 5.25098C9.71229 5.26544 8.82584 5.83277 8.66675 6.5326L6.24814 17.2311C6.08811 17.9319 6.52247 18.5029 7.21903 18.5132H12.9287C12.2312 18.5029 11.7982 17.9319 11.9573 17.2311Z'
          fill='#024381'
        />
      </g>
      <mask
        id='mask2_3_7834'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='1'
        y='5'
        width='10'
        height='14'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.5 5.25H10.4167V18.5132H1.5V5.25Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2_3_7834)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.24799 17.231L8.6666 6.53252C8.82569 5.83269 9.71214 5.26536 10.4166 5.2509L5.72451 5.2495C5.01629 5.2495 4.10837 5.82336 3.94601 6.53252L1.52787 17.231C1.51294 17.2963 1.50454 17.3603 1.49988 17.4228V17.6211C1.54747 18.1324 1.9375 18.5043 2.49877 18.5131H7.21935C6.52232 18.5029 6.08796 17.9318 6.24799 17.231Z'
          fill='#DD0228'
        />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.9229 14.3692H13.4524L13.4426 14.5982H13.5835C13.6544 14.5982 13.6899 14.5754 13.6899 14.5306L13.7314 14.3822H14.1718L14.113 14.5982C14.0631 14.7783 13.9315 14.8726 13.7174 14.8819H13.4356L13.4342 15.2733C13.4286 15.3358 13.4855 15.368 13.6026 15.368H13.8672L13.7818 15.6783H13.1463C12.9681 15.6867 12.8804 15.6018 12.8823 15.4217L12.9229 14.3692ZM13.5425 13.9096C13.6101 13.9189 13.6484 13.8919 13.6526 13.8284L13.709 13.6264H12.7904L12.7134 13.9096H13.5425ZM13.8746 13.0189H12.9574L12.8477 13.4029C12.8477 13.4029 13.0008 13.2928 13.256 13.2891C13.5103 13.2849 13.8009 13.2891 13.8009 13.2891L13.8746 13.0189ZM13.0045 12.6172L12.9789 12.8384C12.9789 12.8384 13.2849 12.6088 13.5634 12.6088H14.5908L14.1975 14.0309C14.1653 14.1937 14.0253 14.2744 13.7785 14.2744H12.614L12.3411 15.2733C12.3257 15.327 12.3476 15.354 12.4064 15.354H12.6355L12.5515 15.6643H11.9688C11.7453 15.6643 11.652 15.5971 11.6888 15.4618L12.46 12.6172H13.0045ZM10.4142 13.5452H12.0369L11.9333 13.9231H11.2806L11.1812 14.2884H11.8162L11.7131 14.6663H11.0777L10.9302 15.2052C10.8934 15.2952 10.9414 15.3358 11.0735 15.327H11.5913L11.4952 15.6783H10.5015C10.313 15.6783 10.2486 15.5705 10.3074 15.354L10.4959 14.6663H10.09L10.1931 14.2884H10.5994L10.6988 13.9231H10.3106L10.4142 13.5452ZM10.5155 13.0469H10.6041C10.6858 13.0469 10.7408 13.0189 10.7665 12.9648L10.9974 12.6196H11.6151L11.4859 12.8468H12.2268L12.133 13.1948H11.2512C11.15 13.3479 11.0249 13.4192 10.8747 13.4109H10.4156L10.5155 13.0469Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.50723 10.7221C6.43538 11.0739 6.26883 11.3441 6.01082 11.5363C5.75468 11.7248 5.42483 11.8195 5.0208 11.8195C4.64056 11.8195 4.36156 11.7229 4.18427 11.5288C4.06063 11.3912 3.99951 11.2162 3.99951 11.0044C3.99951 10.9172 4.00978 10.8234 4.0303 10.7221L4.46093 8.64645H5.11131L4.68674 10.6984C4.67368 10.7553 4.66855 10.8085 4.66902 10.856C4.66855 10.961 4.69421 11.0473 4.7474 11.1145C4.82438 11.2144 4.94941 11.2638 5.12344 11.2638C5.32312 11.2638 5.48828 11.2148 5.61612 11.1164C5.74395 11.0184 5.82747 10.8794 5.86526 10.6984L6.29122 8.64645H6.93786L6.50723 10.7221Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.39808 9.23048H9.91175L9.81611 9.68024H9.30197L9.39808 9.23048ZM9.23759 9.90558H9.74707L9.34816 11.7578H8.84009L9.23759 9.90558Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.1682 11.2502C11.2578 11.1532 11.3222 11.0053 11.3614 10.8089C11.3674 10.7781 11.3721 10.7463 11.3758 10.7142C11.3791 10.6829 11.3805 10.6535 11.3805 10.6269C11.3805 10.5126 11.3511 10.424 11.2928 10.361C11.2349 10.2975 11.1519 10.2667 11.0455 10.2667C10.9046 10.2667 10.7894 10.3162 10.6993 10.4151C10.6088 10.5145 10.5444 10.6647 10.5038 10.8644C10.4983 10.8952 10.4936 10.926 10.4894 10.9558C10.4866 10.9866 10.4852 11.0151 10.4861 11.0412C10.4861 11.1546 10.515 11.2423 10.5734 11.3043C10.6317 11.3664 10.7138 11.3972 10.8216 11.3972C10.9634 11.3972 11.0786 11.3482 11.1682 11.2502ZM10.1978 11.6169C10.0644 11.4896 9.99717 11.3183 9.9967 11.1C9.9967 11.0627 9.99904 11.0202 10.0037 10.974C10.0088 10.9269 10.0149 10.8812 10.0238 10.8392C10.0839 10.5383 10.2127 10.2989 10.411 10.1226C10.6088 9.94621 10.8472 9.8571 11.1267 9.8571C11.3553 9.8571 11.5373 9.92102 11.6698 10.0489C11.8027 10.1776 11.869 10.3512 11.869 10.5719C11.869 10.6097 11.8662 10.6535 11.8615 10.7006C11.8555 10.7482 11.8485 10.7939 11.8401 10.8392C11.7808 11.135 11.653 11.3715 11.4547 11.5446C11.2564 11.7186 11.0185 11.8054 10.7413 11.8054C10.5113 11.8054 10.3308 11.7429 10.1978 11.6169Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1233 5.25248L14.0789 5.25201L16.1116 5.25295C16.1154 5.25295 16.1196 5.25248 16.1233 5.25248Z'
        fill='#E02F41'
      />
      <mask
        id='mask3_3_7834'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='10'
        y='5'
        width='5'
        height='1'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4165 5.25H14.0789V5.71646H10.4165V5.25Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask3_3_7834)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.0789 5.25181L10.4445 5.24994C10.4352 5.24994 10.4258 5.25041 10.4165 5.25134L14.0789 5.25181Z'
          fill='#2E4F7D'
        />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0582 13.3862H18.9487L18.8377 13.7776H18.2358L18.1327 14.142H18.7341L18.6226 14.5329H17.9526L17.801 14.762H18.129L18.2045 15.2211C18.2139 15.2668 18.254 15.2892 18.323 15.2892H18.4252L18.3184 15.6671H17.9577C17.7711 15.676 17.6745 15.6135 17.6666 15.4782L17.5798 15.0592L17.2817 15.5052C17.2113 15.6312 17.1025 15.69 16.9565 15.6807H16.406L16.5133 15.3028H16.685C16.7554 15.3028 16.8142 15.2715 16.8669 15.2081L17.3335 14.5329H16.7316L16.8436 14.142H17.4963L17.5999 13.7776H16.9467L17.0582 13.3862ZM17.2295 12.6033H17.8131L17.8374 12.8188C17.8336 12.8734 17.8663 12.9 17.9353 12.9H18.0389L17.9344 13.2649H17.5052C17.3414 13.2733 17.2574 13.2107 17.2495 13.0754L17.2295 12.6033ZM15.7276 15.1003L15.8466 14.6813H15.3833L15.2639 15.1003H15.7276ZM15.6115 13.8723L15.4533 14.4504C15.4533 14.4504 15.7528 14.3025 15.9586 14.2899C16.0178 14.0669 16.0771 13.8723 16.0771 13.8723H15.6115ZM15.8429 13.0624L15.6847 13.6138C15.6847 13.6138 15.9553 13.5103 16.1881 13.4809C16.2394 13.2882 16.3071 13.0624 16.3071 13.0624H15.8429ZM15.1729 13.0624L15.2956 12.6304H15.9166L15.89 12.789C15.89 12.789 16.2068 12.6304 16.4354 12.6304H17.2033L17.0811 13.0624H16.9603L16.3813 15.1003H16.5021L16.3873 15.5052H16.2665L16.2161 15.6807H15.6147L15.6651 15.5052H14.4791L14.5948 15.1003H14.7133L15.2928 13.0624H15.1729Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.10616 9.9048H7.56525L7.51299 10.1726L7.57878 10.0961C7.72761 9.937 7.90863 9.85768 8.12184 9.85768C8.315 9.85768 8.4545 9.91413 8.54221 10.027C8.62805 10.1399 8.65185 10.2958 8.61079 10.4964L8.35792 11.7589H7.88577L8.11438 10.6144C8.13771 10.4964 8.13118 10.4082 8.09525 10.3513C8.05933 10.2944 7.99074 10.2664 7.89183 10.2664C7.77053 10.2664 7.66836 10.3042 7.58484 10.3793C7.50133 10.4553 7.44628 10.5603 7.41922 10.6937L7.2088 11.7589H6.73572L7.10616 9.9048Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3724 9.9048H12.832L12.7802 10.1726L12.845 10.0961C12.9943 9.937 13.1753 9.85768 13.3881 9.85768C13.5812 9.85768 13.7212 9.91413 13.808 10.027C13.8934 10.1399 13.9181 10.2958 13.8766 10.4964L13.6246 11.7589H13.152L13.3806 10.6144C13.4039 10.4964 13.3974 10.4082 13.3615 10.3513C13.3242 10.2944 13.257 10.2664 13.1585 10.2664C13.0372 10.2664 12.9355 10.3042 12.8511 10.3793C12.7676 10.4553 12.712 10.5603 12.6859 10.6937L12.4746 11.7589H12.002L12.3724 9.9048Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.9776 10.1508H15.5711C15.726 10.1508 15.8487 10.1149 15.9383 10.044C16.0269 9.97213 16.0857 9.86249 16.1183 9.71366C16.1235 9.68613 16.1267 9.6614 16.1305 9.63854C16.1328 9.61661 16.1351 9.59562 16.1351 9.57462C16.1351 9.46825 16.0973 9.39127 16.0218 9.34275C15.9457 9.29376 15.8272 9.27043 15.6625 9.27043H15.1586L14.9776 10.1508ZM14.6445 8.75583H15.9788C16.235 8.75583 16.4337 8.81415 16.57 8.92799C16.7057 9.04369 16.7738 9.20932 16.7738 9.4258V9.43186C16.7738 9.47339 16.771 9.51958 16.7668 9.56996C16.7603 9.61942 16.7519 9.66981 16.7407 9.72206C16.6824 10.0081 16.5457 10.2376 16.3348 10.4121C16.1235 10.5856 15.8725 10.6734 15.5841 10.6734H14.8689L14.6473 11.7586H14.0277L14.6445 8.75583Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.5466 12.1171C19.3506 12.5337 19.164 12.7763 19.0544 12.8892C18.9447 13.0012 18.7273 13.261 18.2039 13.2414L18.2491 12.9233C18.6895 12.7875 18.9279 12.1758 19.0637 11.9048L18.9018 9.91026L19.2424 9.90559H19.5284L19.5592 11.1569L20.0948 9.90559H20.6374L19.5466 12.1171Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.6967 11.0113C17.6025 11.2889 17.3925 11.4722 17.2278 11.42C17.0636 11.3691 17.0048 11.1013 17.1 10.8232C17.1938 10.5452 17.4051 10.3623 17.5689 10.4145C17.7331 10.4654 17.7928 10.7332 17.6967 11.0113ZM18.0294 10.0562L17.8138 10.2046C17.589 10.0282 17.3832 9.91906 16.9866 10.1034C16.4459 10.3539 15.9943 12.2761 17.4826 11.643L17.5675 11.7438L18.153 11.7587L18.5375 10.0119L18.0294 10.0562Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_3_7834'>
        <rect
          width='21'
          height='13.2632'
          fill='white'
          transform='translate(1.5 5.25)'
        />
      </clipPath>
    </defs>
  </svg>
)
